import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// gtag.js is loaded in public/index.html with Google Consent Mode v2
// (analytics_storage denied by default). This component:
// 1) sends a page_view on every route change (SPA tracking)
// 2) updates consent in real time when the CookieBanner broadcasts a choice
export default function GoogleAnalytics() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    if (lastPath.current === path) return; // avoid duplicate page_view
    lastPath.current = path;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.origin + path,
      page_title: document.title,
    });
  }, [location]);

  useEffect(() => {
    const onConsentChange = (e) => {
      if (typeof window.gtag !== "function") return;
      const granted = e?.detail?.value === "all";
      const state = granted ? "granted" : "denied";
      window.gtag("consent", "update", {
        analytics_storage: state,
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state,
      });
      if (granted) {
        // Force a fresh hit so Tag Assistant / GA4 Realtime immediately
        // reflect the new consent state (gcs=G111).
        window.gtag("event", "consent_granted", { event_category: "consent" });
      }
    };
    window.addEventListener("scudononni:cookie-consent", onConsentChange);
    return () =>
      window.removeEventListener("scudononni:cookie-consent", onConsentChange);
  }, []);

  return null;
}
